import { BrowserRouter as Router } from 'react-router-dom';
import { RecoilRoot } from 'recoil';

import AuthSwitch from './pages/switch-logged/AuthSwitch';
import { AlertProvider } from './utils/AlertContext';
import { AuthProvider } from './utils/AuthProvider';
import { ModalProvider } from './utils/ModalContext';

import './App.scss';
import { RemixSseProvider } from 'remix-sse/client';
import CookiePopup from './components/molecules/cookie-popup/CookiePopup';

function App() {
  return (
    <AuthProvider>
      <Router>
        <RecoilRoot>
          <ModalProvider>
            <AlertProvider>
              <RemixSseProvider>
                <div className="app h-screen">
                  <AuthSwitch />
                  <CookiePopup />
                </div>
              </RemixSseProvider>
            </AlertProvider>
          </ModalProvider>
        </RecoilRoot>
      </Router>
    </AuthProvider>
  );
}

export default App;
